const Circle = ({ ...props }) => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      // fill="none"
      stroke="currentColor"
      {...props}
    >
      <circle
        cx="14.5"
        cy="14.23"
        r="13"
        fill="black"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  )
}

export default Circle
